//SnackBar Store  state and functions
export default {
    state: {
        data: [],
        open: false,
        message: 'info',
        currentLiveMessage: {
            message: '',
            name: '',
            image: '',
            url: ''
        }
    },
    functions: {
        async add(notification, read, silent) {
            let state = this.state;
            state.notifications.data.unshift({
                title: notification.title,
                body: notification.body,
                url: notification.url,
                type: notification.data.type,
                data: notification,
                read: read || false,
            });
            if (notification.data.type !== 'live-chat' && !silent)
                this.notifications.show(notification.title);
            else state.notifications.currentLiveMessage = {
                message: notification.data.message,
                name: notification.data.name,
                image: notification.data.image,
                url: notification.data.url
            }
            this.setState(state);
        },
        async show(message) {
            let state = this.state;
            state.notifications.open = true;
            state.notifications.message = message;
            this.setState(state);
            setTimeout(() => this.notifications.hide(), 2000);
        },
        async markAsRead() {
            let state = this.state;
            state.notifications.data.forEach(items => {
                items.read=true;
            });
            this.setState(state);
        },
        async hide() {
            let state = this.state;
            state.notifications.open = false;
            state.notifications.message = '';
            this.setState(state);
        },
        async clearLiveMessage() {
            let notifications = this.state.notifications;
            notifications.currentLiveMessage = {
                message: '',
                name: '',
                image: '',
                url: ''
            }
            this.setState({ notifications: notifications });
        },
    }
}


